"use strict";

var RepositorioBrowserStorage = function(config) {
    this.storage = config.storage === "localStorage" ? window.localStorage : window.sessionStorage;
};

RepositorioBrowserStorage.prototype.getItem = function(key) {
    var that = this;
    return new Promise(function(resolve) {
        if(!key) {
            resolve(void(0));
            return;
        }
        var obj = that.storage.getItem(key);
        if(obj) {
            obj = JSON.parse(obj);
            var agora = Date.now();
            if(agora > obj.tempoExpira) {
                obj = void(0);
                delete that.storage[key];
            } else {
                obj = obj.value;
            }
        }
        resolve(obj);
    });
};

RepositorioBrowserStorage.prototype.setItem = function(key, value, timeout) {
    var that = this;
    return new Promise(function(resolve) {
        var obj = {
            tempoExpira: (Date.now() + (timeout || 0)),
            value: value
        };
        try {
            that.storage.setItem(key, JSON.stringify(obj));
        } catch(ee) {
            console.error(ee);
        }
        resolve();
    });
};

RepositorioBrowserStorage.prototype.delItem = function(key) {
    var that = this;
    return new Promise(function(resolve) {
        delete that.storage[key];
        resolve();
    });
};

module.exports = RepositorioBrowserStorage;
